if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        this.lastScrollTop = window.scrollY;
        this.scrollDelta = 0;
        this.scrollThreshold = 8; // px in one direction before toggling
        this.bottomReserve = 120; // px above page bottom where the bar hides
        this.ticking = false;
        this.boundOnScroll = this.onScroll.bind(this);
        this.boundOnResize = this.calculateHeight.bind(this);

        this.calculateHeight();
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        window.addEventListener('resize', this.boundOnResize, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.boundOnScroll);
        window.removeEventListener('resize', this.boundOnResize);

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      // rAF-throttled scroll handler. We accumulate a directional delta and
      // only flip show/hide once it crosses `scrollThreshold` — that's what
      // kills the per-frame flicker / "jumping" the bar was doing before.
      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.evaluate();
          this.ticking = false;
        });
      }

      evaluate() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        const scrollTop = Math.max(0, window.scrollY);
        const delta = scrollTop - this.lastScrollTop;
        this.lastScrollTop = scrollTop;

        // If we're at/very near the bottom of the document, hide so the bar
        // doesn't overlap the footer/end-of-page CTA area.
        const scrollHeight = document.documentElement.scrollHeight;
        const viewportH = window.innerHeight;
        if (scrollHeight - (scrollTop + viewportH) <= this.bottomReserve) {
          this.scrollDelta = 0;
          this.hide();
          return;
        }

        // Top of page: always show.
        if (scrollTop < 40) {
          this.scrollDelta = 0;
          this.show();
          return;
        }

        // Accumulate delta in current direction; reset on direction flip.
        if ((delta > 0 && this.scrollDelta < 0) || (delta < 0 && this.scrollDelta > 0)) {
          this.scrollDelta = delta;
        } else {
          this.scrollDelta += delta;
        }

        if (this.scrollDelta > this.scrollThreshold) {
          this.scrollDelta = 0;
          this.hide();
        } else if (this.scrollDelta < -this.scrollThreshold) {
          this.scrollDelta = 0;
          this.show();
        }
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
